export default {
  wrapperPaddingTop: '$6',
  wrapperPaddingBottom: '$2',
  wrapperPaddingX: '$4',
};
